import { t } from '@lingui/core/macro';
import { CarRecordMinimal, TireTreadDepthStatus } from '@navio/nsdk';

interface TireOfferDescriptionProps {
  car: CarRecordMinimal;
  treadDepthStatus?: TireTreadDepthStatus;
}

const getGenericTireOfferMessage = (car: CarRecordMinimal) => {
  const carMake = car.make;
  return t`We've prepared a tire offer for your ${carMake}, tailored to the right specifications for safe and comfortable driving`;
};

export const TireOfferDescription = ({ car, treadDepthStatus: status }: TireOfferDescriptionProps) => {
  if (!status) {
    return getGenericTireOfferMessage(car);
  }

  const carMake = car.make;

  switch (status) {
    case TireTreadDepthStatus.WORN_OUT:
      return t`Our measurements of your ${carMake} show that your tires need to be replaced at once.`;
    case TireTreadDepthStatus.SOON_WORN_OUT:
      return t`Our measurements of your ${carMake} show that your tires will soon be below the legal tread depth`;
    case TireTreadDepthStatus.ABOVE_RECOMMENDED:
      return getGenericTireOfferMessage(car);

    default:
      return null;
  }
};
